<ng-template *ngIf="asyncData$ | async"> </ng-template>
<h1 mat-dialog-title class="mb-0">
  {{ "dg.support-request.Tab" | translate }}
</h1>
<mat-dialog-content
  style="height: calc(100% - 70px); max-height: unset"
  class="support-req"
>
  <mat-horizontal-stepper linear #stepper>
    <mat-step [stepControl]="supportConfig">
      <form class="form-group mb-0" [formGroup]="supportConfig">
        <ng-template matStepLabel>{{
          "dg.support-request.Heading" | translate
        }}</ng-template>
        <div class="row">
          <div class="col-md-7">
            <mat-label class="required-field labelColor">Category</mat-label>
            <div class="row pt-2 d-flex justify-content-between">
              <!-- <div class="col-md-4">
                <div
                  class="d-flex flex-column bd-highlight mb-2 cat"
                  (click)="showField(1, '472075')"
                >
                  <button
                    mat-raised-button
                    [class.selectedCat]="showFieldFlag === 1"
                    aria-label="Application"
                    [disabled]="disableCategories?.includes('472075')"
                  >
                    <mat-icon class="icon">laptop_chromebook</mat-icon>
                  </button>
                  <mat-label class="text-center mt-1">Application</mat-label>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="d-flex flex-column bd-highlight mb-2 cat"
                  (click)="showField(2, '472076')"
                >
                  <button
                    mat-raised-button
                    [class.selectedCat]="showFieldFlag === 2"
                    aria-label="Hardware"
                    [disabled]="disableCategories?.includes('472076')"
                  >
                    <mat-icon class="icon">settings</mat-icon>
                  </button>
                  <mat-label class="text-center mt-1">Hardware</mat-label>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="d-flex flex-column bd-highlight mb-2 cat"
                  (click)="showField(3, '472077')"
                >
                  <button
                    mat-raised-button
                    [class.selectedCat]="showFieldFlag === 3"
                    [disabled]="disableCategories?.includes('472077')"
                    aria-label="Network"
                  >
                    <mat-icon class="icon">wifi</mat-icon>
                  </button>
                  <mat-label class="text-center mt-1">Network</mat-label>
                </div>
              </div> -->

              <div class="col-md-4" *ngFor="let catType of catList">
                <div
                  class="d-flex flex-column bd-highlight mb-2 cat"
                  (click)="showField(catType?.optionValue)"
                >
                  <button
                    mat-raised-button
                    [class.selectedCat]="
                      this.supportConfig?.controls['cat']?.value?.optionValue ==
                      catType.optionValue
                    "
                    [attr.aria-label]="catType?.optionText"
                    [disabled]="
                      disableCategories?.includes(catType?.optionValue)
                    "
                  >
                    <mat-icon class="icon">{{ catType?.optionDesc }}</mat-icon>
                  </button>
                  <mat-label class="text-center mt-1">{{
                    catType?.optionText
                  }}</mat-label>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <mat-label
                  class="pb-0 mb-0 labelColor ng-select-label"
                  for="type"
                  [class.required-field]="typeList && typeList?.length > 0"
                  >{{ "dg.support-request.Type" | translate }}</mat-label
                >
                <ng-select
                  appearance="fill"
                  [items]="typeList"
                  bindLabel="optionText"
                  formControlName="type"
                  [class.required-select-field]="
                    typeList && typeList?.length > 0
                  "
                  appendTo="body"
                  placeholder="{{ 'dg.support-request.Type' | translate }}"
                  [matTooltip]="
                    supportConfig?.controls?.type?.value?.optionText.length > 30
                      ? supportConfig?.controls?.type?.value?.optionText
                      : ''
                  "
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div
                      [matTooltip]="
                        item.optionText.length > 30 ? item.optionText : ''
                      "
                      [matTooltipPosition]="tooltipPossition"
                      class="text-truncate"
                    >
                      {{ item.optionText }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-md-6">
                <mat-label
                  class="pb-0 mb-0 labelColor ng-select-label"
                  [class.required-field]="
                    subTypeList && subTypeList?.length > 0
                  "
                  >{{ "dg.support-request.Subtype" | translate }}</mat-label
                >
                <ng-select
                  appearance="fill"
                  [items]="subTypeList"
                  bindLabel="optionText"
                  formControlName="subtype"
                  [class.required-select-field]="
                    subTypeList && subTypeList?.length > 0
                  "
                  appendTo="body"
                  placeholder="{{ 'dg.support-request.Subtype' | translate }}"
                  [matTooltip]="
                    supportConfig?.controls?.subtype?.value?.optionText.length >
                    30
                      ? supportConfig?.controls?.subtype?.value?.optionText
                      : ''
                  "
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div
                      [matTooltip]="
                        item.optionText.length > 30 ? item.optionText : ''
                      "
                      [matTooltipPosition]="tooltipPossition"
                      class="text-truncate"
                    >
                      {{ item.optionText }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 pt-2 d-inline" *ngIf="!severityShow">
                <mat-label class="ng-select-label labelColor">
                  {{ "dg.support-request.Priority" | translate }}</mat-label
                >
                <ng-select
                  appearance="fill"
                  [items]="priorityList"
                  bindLabel="optionText"
                  formControlName="priority"
                  appendTo="body"
                  placeholder="{{ 'dg.support-request.Priority' | translate }}"
                  [matTooltip]="
                    supportConfig?.controls?.priority?.value?.optionText
                      .length > 30
                      ? supportConfig?.controls?.priority?.value?.optionText
                      : ''
                  "
                >
                </ng-select>
                <ng-template ng-option-tmp let-item="item">
                  <div
                    [matTooltip]="
                      item.optionText.length > 30 ? item.optionText : ''
                    "
                    [matTooltipPosition]="tooltipPossition"
                    class="text-truncate"
                  >
                    {{ item.optionText }}
                  </div>
                </ng-template>
              </div>
              <!-- <div *ngIf="!severityShowS">
                {{ supportConfig?.controls?.priority?.value?.optionDesc }}
              </div> -->
              <div class="col-md-6 pt-2 d-inline" *ngIf="severityShow">
                <mat-label class="ng-select-label labelColor">
                  {{ "dg.support-request.Severity" | translate }}</mat-label
                >
                <ng-select
                  appearance="fill"
                  [items]="severityList"
                  bindLabel="optionText"
                  formControlName="severity"
                  appendTo="body"
                  placeholder="{{ 'dg.support-request.Severity' | translate }}"
                  [matTooltip]="
                    supportConfig?.controls?.severity?.value?.optionText
                      .length > 30
                      ? supportConfig?.controls?.severity?.value?.optionText
                      : ''
                  "
                >
                </ng-select>
                <ng-template ng-option-tmp let-item="item">
                  <div
                    [matTooltip]="
                      item.optionText.length > 30 ? item.optionText : ''
                    "
                    [matTooltipPosition]="tooltipPossition"
                    class="text-truncate"
                  >
                    {{ item.optionText }}
                  </div>
                </ng-template>
              </div>
              <div class="col-md-6 pt-2 d-inline">
                <mat-label class="pb-0 mb-0 labelColor ng-select-label">{{
                  "dg.support-request.Time" | translate
                }}</mat-label>

                <ng-select
                  appearance="fill"
                  [items]="timeList"
                  bindLabel="optionText"
                  formControlName="time"
                  appendTo="body"
                  placeholder="{{ 'dg.support-request.Time' | translate }}"
                  [matTooltip]="
                    supportConfig?.controls?.time?.value?.optionText.length > 30
                      ? supportConfig?.controls?.time?.value?.optionText
                      : ''
                  "
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div
                      [matTooltip]="
                        item.optionText.length > 30 ? item.optionText : ''
                      "
                      [matTooltipPosition]="tooltipPossition"
                      class="text-truncate"
                    >
                      {{ item.optionText }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="mt-1 mb-2 col-md-6" *ngIf="severityShow">
                {{ supportConfig?.controls?.severity?.value?.optionDesc }}
              </div>
            </div>
          </div>
          <div class="col-md-5" float-end>
            <div class="textAreaDiv">
              <div class="labelColor required-field">
                {{ "dg.support-request.Desc" | translate }}
              </div>
              <div class="pt-2 h-100 w-100">
                <textarea
                  cols="100"
                  formControlName="desc"
                  apperance="fill"
                  (blur)="onBlurDesc()"
                  (click)="onDescClick()"
                  [maxLength]="maxChars"
                >
                </textarea>
                <mat-error *ngIf="showMinlengthMsg">
                  {{ "dg.support-request.Error" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="supportConfig?.controls?.desc?.value?.length == 2000"
                  style="color: inherit"
                >
                  Max character (2000) limit reached
                </mat-error>
                <!-- <mat-error
                  *ngIf="supportConfig?.controls?.desc?.errors?.pattern"
                >
                  {{ "dg.support-request.Error1" | translate }}
                </mat-error> -->
              </div>
            </div>
          </div>
        </div>
        <mat-label class="labelColor">{{
          "dg.support-request.Attachment" | translate
        }}</mat-label>
        <div class="supportAttachment">
          <dg-file-upload
            #dgFileUpload
            [attachSmall]="true"
            [multiple]="true"
            [edit]="true"
            [acceptedType]="appAcceptedType"
            [isDownload]="true"
            [attachId]="appAttachID"
            [maxSize]="appMaxSize"
            [maxfiles]="appMaxFiles"
            (finalPath)="onFinalPath($event)"
            [title]="''"
            [uniqueAttachmentId]="attachmentID"
            [allowUpdate]="true"
            [allowFileToAttach]="true"
            [allowDelete]="true"
            [mandatory]="false"
            [isPreviewIcon]="true"
            [refreshAttachComponent]="isRefresh"
          >
          </dg-file-upload>
        </div>
      </form>
    </mat-step>
    <mat-step optional>
      <ng-template matStepLabel>{{
        "dg.support-request.Reftab" | translate
      }}</ng-template>
      <div class="supportReqListbox">
        <dynamic-grid
          [cols]="columnConfig"
          [rows]="content"
          [isRowSelectable]="true"
          [allowMultiRowSelection]="true"
          [showCheckboxForSelection]="true"
          [isLoading]="false"
          [showSearch]="false"
          [canAddRow]="false"
          [isExternalPaging]="false"
          [isExternalSearch]="false"
          [isExternalSorting]="false"
          [totalRows]="5"
          (onRowSelection)="dgListData($event)"
        ></dynamic-grid>
        <!-- <dg-listbox
          #listbox
          [content]="content"
          [columnConfig]="columnConfig"
          [isSelectable]="isSelectable"
          [multiple]="true"
          [pageSizeOption]="[4, 10, 25]"
          (output)="dgListData($event)"
        > -->
        <!-- <ng-container class="listbox-search-placeholder">{{
            "dg.support-request.Search" | translate
          }}</ng-container>
        </dg-listbox> -->
      </div>
    </mat-step>
    <mat-step [stepControl]="detailConfig"
      ><form [formGroup]="detailConfig">
        <ng-template matStepLabel>
          <!--  {{
            data.other
              ? "Verify Employee Details (Other)"
              : "Verify Employee Details (Self)"
          }} -->
          Verify Employee Details
        </ng-template>

        <div class="row d-flex justify-content-start">
          <div class="col-md-4 pt-2">
            <mat-label class="label labelColor"
              >&nbsp;{{ "dg.support-request.Raisefor" | translate }}</mat-label
            >

            <div class="supportReqToggle">
              <mat-button-toggle-group
                appearance="legacy"
                formControlName="toggle"
                name="fontStyle"
                aria-label="Font Style"
              >
                <mat-button-toggle value="self">{{
                  "dg.support-request.Toggleself" | translate
                }}</mat-button-toggle>
                <mat-button-toggle value="other">{{
                  "dg.support-request.Toggleother" | translate
                }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div
            class="col-md-4 emp mt-1"
            *ngIf="detailConfig.get('toggle').value != 'self'"
          >
            <mat-label> Name</mat-label>
            <dg-employee-search
              #empSearch
              [empConfig]="empSearchConfig"
              [orgConfig]="orgConfig"
              [showEmpIdDsgnName]="false"
              [showEmailId]="false"
              (output)="getEmpData($event)"
            >
            </dg-employee-search>
          </div>
          <!-- <mat-form-field
            class="col-md-6 field matInputDiv"
            *ngIf="detailConfig.get('toggle').value === 'self'"
          >
            <mat-label>{{ "dg.support-request.Name" | translate }}</mat-label>
            <input type="text" matInput formControlName="name" readonly />
          </mat-form-field> -->
          <div
            class="col-md-4 field"
            *ngIf="detailConfig.get('toggle').value === 'self'"
          >
            <mat-label class="labelColor">
              {{ "dg.support-request.Name" | translate }}</mat-label
            >
            <div class="mt-1">{{ detailConfig?.controls?.name?.value }}</div>
          </div>
          <div
            class="col-md-4 field"
            *ngIf="detailConfig?.controls?.department?.value"
          >
            <mat-label class="labelColor">
              {{ "dg.support-request.Dept" | translate }}</mat-label
            >
            <div class="mt-1">
              {{ detailConfig?.controls?.department?.value }}
            </div>
          </div>
          <div class="col-md-4">
            <mat-form-field
              class="field matInputDiv"
              *ngIf="!detailConfig?.controls?.department?.value"
            >
              <mat-label>
                {{ "dg.support-request.Dept" | translate }}</mat-label
              >
              <input
                type="text"
                matInput
                formControlName="department"
                readonly
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row d-flex justify-content-between mt-1">
          <mat-form-field class="col-md-4 field">
            <mat-label class="required-field">{{
              "dg.support-request.Contact" | translate
            }}</mat-label>
            <input
              type="text"
              mask="0000000000"
              matInput
              formControlName="contact"
            /><mat-error
              *ngIf="
                detailConfig.controls?.contact?.touched &&
                (detailConfig.controls?.contact?.errors?.pattern ||
                  detailConfig.controls?.contact?.errors?.required)
              "
            >
              {{ "dg.support-request.Contacterror" | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4 field">
            <mat-label class="required-field">{{
              "dg.support-request.Email" | translate
            }}</mat-label>
            <input type="email" matInput formControlName="email" /><mat-error
              *ngIf="
                detailConfig.controls?.email?.touched &&
                detailConfig.controls?.email?.errors?.required
              "
            >
              {{ "dg.support-request.Emailiderror" | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                detailConfig.controls?.email?.touched &&
                detailConfig.controls?.email?.errors &&
                !detailConfig.controls?.email?.errors?.required
              "
            >
              {{ "dg.support-request.Emailerror" | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4 field">
            <mat-label>{{ "dg.support-request.Desk" | translate }}</mat-label>
            <input
              type="text"
              matInput
              formControlName="desk"
              (blur)="onDeskBlur()"
            />
            <mat-error *ngIf="detailConfig?.controls?.desk?.errors?.pattern">
              {{ "dg.support-request.Error1" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>
<mat-dialog-actions align="end" class="p-0 mt-1 actiomButtonAlign">
  <button
    mat-raised-button
    #matAction
    *ngIf="action"
    class="me-3"
    aria-label="Close"
    (click)="onClose()"
    [disabled]="create"
  >
    {{ "dg.support-request.Btnclose" | translate }}
  </button>
  <button
    mat-raised-button
    class="me-3 ms-0"
    *ngIf="stepper.selectedIndex > 0"
    aria-label="previous"
    (click)="onPrev()"
    [disabled]="create"
  >
    {{ "dg.support-request.Btnprevious" | translate }}
  </button>
  <button
    mat-raised-button
    (click)="onSubmit()"
    color="primary"
    class="ms-0"
    aria-label="submit"
    *ngIf="stepper.selectedIndex === 2"
    [disabled]="supportConfig.invalid || detailConfig.invalid || create"
  >
    {{ "dg.support-request.Btnsubmit" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    class="ms-0"
    aria-label="Next"
    *ngIf="stepper.selectedIndex < 2"
    (click)="onNext()"
    [disabled]="this.supportConfig.invalid"
  >
    {{ "dg.support-request.Btnnext" | translate }}
  </button>
</mat-dialog-actions>
